/**
 * @fileoverview JS - Class - Layer.js
 * @author : Adam Lemire
 * @since 2019/06/19
 * @version 1.0
 * @summary Dernières modifications : 2019/11/27
 */

/**
 * Classe !abstraite Layer de type Template pour ses sous-classes, représente une couche cartographique et contient tous les détails pour son utilisation et sa représentation
 *
 * @abstract
 */
export default class Layer {
  /**
   * @param { number } id
   * @param { string } name
   * @param { boolean } visible
   */
  constructor (id, name = 'unnamed', visible = true) {
    /** @type { number } */
    this._id = id;
    /** @type { string } */
    this._name = name;
    /** @type { boolean } */
    this._visible = visible;
    this._layerNameChangedListeners = [];

    if (this.constructor === Layer) {
      throw new Error('Ne peut instancier une classe abstraite');
    }
  }

  get id () { return this._id; }

  get name () { return this._name; }

  set name (nouveauNom) {
    this._name = nouveauNom;
    this._notifierNomModifié(nouveauNom);
  }

  get isVisible () { return this._visible; }

  set isVisible (value) { this._visible = value; }

  _notifierNomModifié (layerName) {}

  écouterNomModifié (listener) {
    const _this = this;
    this._layerNameChangedListeners.push(listener);
    this._notifierNomModifié = function (element) {
      _this._layerNameChangedListeners.forEach(function (mListener) {
        mListener(element);
      });
    };
  }
}
